// 회원가입 Url은 django view의 chekpluss_main 에서 urlChange를 변경해야함.
export default class Common {
    // static backendUrl = "http://localhost:8000";
    static backendUrl = "https://b.dronesoccer.or.kr";

    // static paginationUrl = "http://localhost:3000";
    static paginationUrl = "https://dronesoccer.or.kr";
}
